var agree = false;

// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll(
    ".cart-shippingThreshold__progress"
  );
  var progressNum = document.querySelectorAll(".cart-shipping__num");
  var progressOuter = document.querySelectorAll(".cart-shipping__numOuter");
  var successMsg = document.querySelectorAll(".cart-shipping__success");
  // calculate how far progress is from the total as a percentage
  var result = Math.round((100 * currentVal) / targetVal);
  progressBar.forEach(function (el) {
    el.setAttribute("style", "width: ".concat(result, "%"));
  });
  // Update the progess text. If threshold is met, show success message
  var newProgressNum = (targetVal - currentVal) / 100;
  if (newProgressNum <= 0) {
    successMsg.forEach(function (el) {
      el.style.display = "block";
    });
    progressOuter.forEach(function (el) {
      el.style.display = "none";
    });
    progressNum.forEach(function (el) {
      el.textContent = newProgressNum;
    });
  } else {
    successMsg.forEach(function (el) {
      el.style.display = "none";
    });
    progressOuter.forEach(function (el) {
      el.style.display = "block";
    });
    progressNum.forEach(function (el) {
      el.textContent = newProgressNum;
    });
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
    // fetch('/cart.js')
    // .then(response => response.json())
    // .then(data => {
    //   var currencyCode = document.querySelector(".cart-shipping__symbol").innerHTML;
    //   console.log(currencyCode)
    //   let targetValue;
    //   if(currencyCode === "DKK") {
    //     targetValue = 1100;
    //   }
    //   if(currencyCode === "USD") {
    //     targetValue = 150;
    //   }
    //   if (currencyCode === "EUR"){
    //     targetValue = 150;
    //   }
    //   if (currencyCode === "GBP"){
    //     targetValue = 150;
    //   }
    //   calculateProgress(data.total_price, targetValue);
    //   if (data.total_price > targetValue) {
    //     document.querySelector('.totals__shipping-value').textContent = 'Free shipping on all orders';
    //   }
    // });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        if (typeof initDelivery === "function") {
          initDelivery();
        }

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });

    let agreeInput = document.querySelector(
      '.terms-container input[type="checkbox"]'
    );
    if (agreeInput.checked) {
      agree = true;
    } else {
      agree = false;
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    let agreeInput = document.querySelector(
      '.terms-container input[type="checkbox"]'
    );
    if (agree) {
      agreeInput.checked = true;
    }
    redoCartJS();

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}

function redoCartJS() {
  // Function to check if the checkbox is checked
  function isCheckboxChecked() {
    document.querySelector('.terms-container input[type="checkbox"]');

    return checkbox.checked;
  }

  // Function to disable checkout buttons
  function disableCheckoutButtons() {
    var checkoutButtons = document.querySelectorAll(".cart__checkout-button");
    checkoutButtons.forEach(function (button) {
      button.disabled = true;
    });
  }

  // Function to enable checkout buttons
  function enableCheckoutButtons() {
    var checkoutButtons = document.querySelectorAll(".cart__checkout-button");
    checkoutButtons.forEach(function (button) {
      button.disabled = false;
    });
  }

  // Function to disable buttons within dynamic-checkout__content
  function disableDynamicCheckoutButtons() {
    var dynamicCheckoutButtons = document.querySelectorAll(
      ".dynamic-checkout__content button"
    );
    dynamicCheckoutButtons.forEach(function (button) {
      button.disabled = true;
      button.style.pointerEvents = "none";
    });
  }

  // Function to enable buttons within dynamic-checkout__content
  function enableDynamicCheckoutButtons() {
    var dynamicCheckoutButtons = document.querySelectorAll(
      ".dynamic-checkout__content button"
    );
    dynamicCheckoutButtons.forEach(function (button) {
      button.disabled = false;
      button.style.pointerEvents = "auto";
    });
  }

  // Function to handle checkbox change event
  function handleCheckboxChange(event) {
    var isChecked = event.target.checked;
    var checkboxes = document.querySelectorAll(
      '.terms-container input[type="checkbox"]'
    );

    checkboxes.forEach(function (checkbox) {
      checkbox.checked = isChecked;
    });

    if (isChecked) {
      enableCheckoutButtons();
      enableDynamicCheckoutButtons();
    } else {
      disableCheckoutButtons();
      disableDynamicCheckoutButtons();
    }
  }

  // Add event listener to the checkboxes
  var checkboxes = document.querySelectorAll(
    '.terms-container input[type="checkbox"]'
  );
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", handleCheckboxChange);
  });

  // Call the initial checkbox check
  handleCheckboxChange({ target: checkboxes[0] });
}
